import {
    SELECT_TRANSACTION_QUOTE,
} from 'store/actions/types';

export const selectTransactionQuote = (payload) => {
    return {
        type: SELECT_TRANSACTION_QUOTE,
        selected: payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/transactions/selectTransactions.js